import { NewPaymentContext } from 'components/payment/payment.context';
import { useContext, useEffect } from 'react';
import SpreedlyCheckoutSdkCard from './spreedly-checkout-sdk-card.component';
import { useCheckoutPaymentLoading } from 'pages/checkout/checkout.component';
import SpreedlyContext from 'components/payment/spreedly/spreedly.context';

const SpreedlyCheckoutSdkCardContainer = props => {
  const { refetchInitOrder } = useContext(NewPaymentContext);
  const { tokenizationSuccess } = useContext(SpreedlyContext);
  const addPromise = useCheckoutPaymentLoading(state => state.addPromise);

  useEffect(() => {
    if (tokenizationSuccess) addPromise(refetchInitOrder());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <SpreedlyCheckoutSdkCard {...props} />;
};

export default SpreedlyCheckoutSdkCardContainer;
